import React, { useEffect, useState } from "react";
import { useUserAuth } from "../../context/UserAuthContext";
import axios from "axios";
import dayjs from "dayjs";

const TotalReviews = () => {
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const { user, language, token } = useUserAuth();
  const merchant_id = user.uid;
  const [data, setData] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [vendors, setVendors] = useState([]);

  const fetchVendors = async () => {
    try {
      const res = await axios.get(`${base_url}/api/v1/manager/vendors`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setVendors(res.data.vendors);
    } catch (err) {
      console.log("Error fetching vendors:", err);
    }
  };

  const getEnquireList = async () => {
    const response = await axios.get(`${base_url}/api/v1/manager/reviews`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        vendor_id: selectedVendor || undefined,
      },
    });
    setData(response.data.reviews);
  };

  useEffect(() => {
    if (!merchant_id) return;
    getEnquireList();
    fetchVendors();
  }, [token, selectedVendor]);

  const RatingStar = ({ value }) => {
    let stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <span key={i} style={{ color: i <= value ? '#ffc107' : '#e4e5e9', fontSize: '1.1rem' }}>
          ★
        </span>
      );
    }
    return <div className="d-inline-flex gap-0">{stars}</div>;
  };

  // Calculate average rating
  const averageRating = data.length > 0 
    ? (data.reduce((sum, item) => sum + item.rating, 0) / data.length).toFixed(1)
    : 0;

  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card shadow-lg border-0 rounded-3">
              <div className="card-body p-4">
                <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
                  <div>
                    <h2 className="mb-1 fw-bold" style={{ color: '#2c3e50' }}>
                      {language === "en" ? "User Ratings & Reviews" : "उपयोगकर्ता रेटिंग और समीक्षाएं"}
                    </h2>
                    {data.length > 0 && (
                      <div className="mt-2">
                        <span className="text-muted me-2">
                          {language === "en" ? "Average Rating:" : "औसत रेटिंग:"}
                        </span>
                        <RatingStar value={parseFloat(averageRating)} />
                        <span className="ms-2 text-muted">
                          ({averageRating} / 5)
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <label className="fw-semibold text-muted">
                      {language === "en" ? "Filter by Vendor:" : "विक्रेता द्वारा फ़िल्टर करें:"}
                    </label>
                    <select
                      className="form-select rounded-pill px-3 py-2"
                      value={selectedVendor || ""}
                      onChange={(e) => setSelectedVendor(e.target.value || null)}
                      style={{ 
                        width: "220px", 
                        borderColor: '#dee2e6',
                        backgroundColor: '#f8f9fa',
                        fontWeight: '500'
                      }}
                    >
                      <option value="">{language === "en" ? "All Vendors" : "सभी विक्रेता"}</option>
                      {vendors.map((v) => (
                        <option key={v.id} value={v.id}>
                          {v.business_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-hover table-bordered shadow-sm rounded-3 overflow-hidden">
                    <thead style={{ backgroundColor: '#f8f9fa' }}>
                      <tr className="text-center">
                        <th style={{ width: '70px', color: '#495057', fontWeight: '600' }}>#</th>
                        <th style={{ color: '#495057', fontWeight: '600' }}>Property</th>
                        <th style={{ width: '180px', color: '#495057', fontWeight: '600' }}>Total Rating</th>
                        <th style={{ color: '#495057', fontWeight: '600' }}>Reviews</th>
                        <th style={{ width: '150px', color: '#495057', fontWeight: '600' }}>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.length > 0 ? (
                        data.map((item, index) => (
                          <tr key={index} className="align-middle" style={{ transition: 'all 0.3s ease' }}>
                            <td className="text-center fw-semibold">{index + 1}</td>
                            <td className="fw-medium">{item.vendor_name}</td>
                            <td className="text-center">
                              <RatingStar value={item.rating} />
                              <span className="ms-2 text-muted small">({item.rating})</span>
                            </td>
                            <td>
                              <div className="review-text" style={{ maxWidth: '400px' }}>
                                "{item.review}"
                              </div>
                            </td>
                            <td className="text-center text-muted">
                              <small>{dayjs(item.created_at).format("DD MMM, YYYY")}</small>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center py-5">
                            <div className="text-muted">
                              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📝</div>
                              <p className="mb-0">
                                {language === "en"
                                  ? "No reviews yet"
                                  : "अभी कोई रिव्यू नहीं है"}
                              </p>
                              <small className="text-muted">
                                {language === "en"
                                  ? "Increase good reviews to perform better"
                                  : "बेहतर प्रदर्शन के लिए अच्छी समीक्षाएँ बढ़ाएँ"}
                              </small>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {data.length > 0 && (
                  <div className="mt-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div className="text-muted">
                      <small>
                        {language === "en" 
                          ? `Showing ${data.length} review${data.length > 1 ? 's' : ''}` 
                          : `${data.length} समीक्षा${data.length > 1 ? 'एं' : ''} दिखा रहे हैं`}
                      </small>
                    </div>
                    <div className="d-flex gap-3">
                      <div className="text-success">
                        <small>★ 5 stars: {data.filter(r => r.rating === 5).length}</small>
                      </div>
                      <div className="text-primary">
                        <small>★ 4 stars: {data.filter(r => r.rating === 4).length}</small>
                      </div>
                      <div className="text-warning">
                        <small>★ 3 stars: {data.filter(r => r.rating === 3).length}</small>
                      </div>
                      <div className="text-secondary">
                        <small>★ 2-1 stars: {data.filter(r => r.rating <= 2).length}</small>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .table-hover tbody tr:hover {
          background-color: #f8f9fa;
          transform: scale(1.01);
          transition: all 0.3s ease;
          cursor: pointer;
        }
        
        .table {
          margin-bottom: 0;
        }
        
        .form-select:focus {
          border-color: #86b7fe;
          box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
        }
        
        .review-text {
          font-style: italic;
          color: #555;
          line-height: 1.5;
        }
        
        @media (max-width: 768px) {
          .d-flex {
            flex-direction: column;
            align-items: flex-start !important;
          }
          
          .table th, .table td {
            font-size: 0.75rem;
            padding: 0.5rem;
          }
          
          .review-text {
            max-width: 200px !important;
            font-size: 0.75rem;
          }
        }
        
        @media (max-width: 992px) {
          .d-flex.gap-3 {
            flex-wrap: wrap;
            gap: 0.5rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default TotalReviews;